var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2 p-0"},[_vm._v(" Copyright © 2024 Dólar Info "),_vm._l((_vm.links),function(link){return _c('router-link',{key:link.text,staticClass:"copyright-link-item",attrs:{"to":link.path}},[_vm._v(" - "+_vm._s(link.text)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }